import React from 'react';
import PropTypes from 'prop-types';
import { Container, Header, Body } from './styled';

const StoriesListEmpty = ({
  header, body, children, borderLeft,
}) => (
  <Container borderLeft={borderLeft}>
    <Header>
      {header}
    </Header>
    <Body>
      {body}
    </Body>
    {children}
  </Container>
);

StoriesListEmpty.propTypes = {
  header: PropTypes.string,
  body: PropTypes.string,
  children: PropTypes.node.isRequired,
  borderLeft: PropTypes.bool,
};

StoriesListEmpty.defaultProps = {
  header: '',
  body: '',
  borderLeft: false,
};

export default StoriesListEmpty;
